<template>
  <div class="project" :id="project.alias">
    <h2 class="heading">
      <span v-if="project.links.website">
        <a :href="project.links.website" target="_blank">{{ project.title }}</a>
      </span>
      <span v-else>{{ project.title }}</span>
      <small class="side-note" @click="scrollTop">
        <router-link v-for="(type, index) in project.types" 
          :key="index" 
          :to="{ name: 'project-type', params: { alias: type.alias } }"
        >{{ type.title }}</router-link>&nbsp;
      </small>
    </h2>
    <p class="description">{{ project.description }}</p>
    <p class="status" @click="scrollTop">
      <router-link 
        :to="{ name: 'project-status', params: { alias: project.status.alias } }" 
        class="hover-light"
      >{{ project.status.title }}</router-link>
    </p>
  </div>
</template>

<script>
export default {
  name: 'project',
  props: {
    project: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      msg: 'Studio 308 Project'
    }
  },
  methods: {
    scrollTop () {
      this.$scrollTo('html, body')
    }
  }
}
</script>

<style lang="sass">
@import ../../assets/styles/scss/variables.scss
@import ../../assets/styles/scss/mixins.scss

.project
  padding-top: 60px
  margin: 0 30px 30px
  text-align: center
  @include transitions(0.3s)

  > .heading
    color: $mainColor

    a
      color: $mainColor

    > .side-note > a
      color: $grey
      margin-right: 5px
      font-size: .9em
      @include transitions(0.3s)

      &:hover
        color: $lightGrey

  > .description
    color: $darkGrey
    margin-bottom: 5px

  > .status
    margin-top: 0px

    > a
      color: $grey
      @include transitions(0.3s)

      &:hover
        color: $lightGrey
</style>



// WEBPACK FOOTER //
// Project.vue?0c26cf17